import produce from 'immer'
import { Reducer } from 'redux'
import { LegislationAct, LegislationActNode, LegislationFolder, LegislationFolderCategory } from 'interfaces/legislation'
import {
  SET_LEGISLATION_FOLDERS,
  SET_LEGISLATION_FOLDERS_MAP,
  SET_LEGISLATION_ACT_ID_MAP,
  SET_LEGISLATION_ACT,
  SET_LEGISLATION_ACTS,
  SET_LEGISLATION_PATH,
  SET_LEGISLATION_ACT_NODES,
  SET_LEGISLATION_ACT_HOVER_ICON_MAP,
  SET_LEGISLATION_SHOW_FAVOURITES_ONLY,
  SET_LEGISLATION_KEYWORD,
  SET_LEGISLATION_SELECTED_AOLS
} from 'redux/actions/types'
import { ActHoverIconMap } from 'types/Legislation'
import { LEGISLATION_FAVOURITES_ONLY_KEY } from 'constants/storage-keys'

export interface LegislationState {
  selectedAols?: string[]
  folders: LegislationFolder[] | null
  foldersMap: Record<string, LegislationFolderCategory[]> | null
  act: string | null
  path: string | null
  actNodes: Record<string, LegislationActNode> | null
  actHoverIconMap: ActHoverIconMap | null
  acts: LegislationAct[] | null
  actIdMap: Record<string, LegislationAct> | null
  keyword?: string
  showFavouritesOnly?: boolean
}

const initialShowFavouritesOnly: boolean = JSON.parse(localStorage.getItem(LEGISLATION_FAVOURITES_ONLY_KEY) ?? 'false')

const initialState: LegislationState = {
  folders: null,
  foldersMap: null,
  act: null,
  path: null,
  actNodes: null,
  actHoverIconMap: null,
  acts: null,
  actIdMap: null,
  keyword: '',
  showFavouritesOnly: initialShowFavouritesOnly,
  selectedAols: []
}
const legislation: Reducer<LegislationState, any> = (state = initialState, action) => {
  switch (action.type) {
    case SET_LEGISLATION_SELECTED_AOLS:
      return produce(state, draft => {
        draft.selectedAols = action.selectedAols
      })
    case SET_LEGISLATION_SHOW_FAVOURITES_ONLY:
      return produce(state, draft => {
        draft.showFavouritesOnly = action.showFavouritesOnly
      })
    case SET_LEGISLATION_KEYWORD:
      return produce(state, draft => {
        draft.keyword = action.keyword
      })
    case SET_LEGISLATION_FOLDERS:
      return produce(state, draft => {
        draft.folders = action.folders
      })
    case SET_LEGISLATION_FOLDERS_MAP:
      return produce(state, draft => {
        draft.foldersMap = action.foldersMap
      })
    case SET_LEGISLATION_ACT_NODES:
      return produce(state, draft => {
        draft.actNodes = action.actNodes
      })
    case SET_LEGISLATION_ACT_HOVER_ICON_MAP:
      return produce(state, draft => {
        draft.actHoverIconMap = action.actHoverIconMap
      })
    case SET_LEGISLATION_ACT:
      return produce(state, draft => {
        draft.act = action.act
      })
    case SET_LEGISLATION_PATH:
      return produce(state, draft => {
        draft.path = action.path
      })
    case SET_LEGISLATION_ACT_ID_MAP:
      return produce(state, draft => {
        draft.actIdMap = action.actIdMap
      })
    case SET_LEGISLATION_ACTS:
      return produce(state, draft => {
        draft.acts = action.acts
      })
    default:
      return state
  }
}

export default legislation
